import { render, staticRenderFns } from "./RichTextPreview.vue?vue&type=template&id=1e0b193f&scoped=true"
import script from "./RichTextPreview.vue?vue&type=script&lang=js"
export * from "./RichTextPreview.vue?vue&type=script&lang=js"
import style0 from "./RichTextPreview.vue?vue&type=style&index=0&id=1e0b193f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0b193f",
  null
  
)

export default component.exports